<div scId="SC1037" id="{{ hardGoodDetails?.offerId }}" class="col-12">
  <div
    *ngIf="hasDeal; else elseBlock"
    class="row magenta-container m-b-sm"
    [ngClass]="hasDeal ? 'visible' : 'errorMessageinvisible col-12'"
  >
    <div class="col-12 m-t-sm m-b-sm">
      <p id="strike-through-price" class="small text-center icon-white">
        {{ currentDeviceDetails?.promotionDescription }}
      </p>
    </div>
  </div>
  <ng-template #elseBlock>
    <div class="row magenta-container m-b-sm" [ngClass]="onSale ? 'visible' : 'invisible col-12'">
      <div class="col-12 m-t-sm m-b-sm" *ngIf="onSale && !isP10MCustomer">
        <p id="strike-through-price" class="small text-center icon-white">
          {{ strikeThroughPriceText }}
        </p>
      </div>
    </div>
  </ng-template>
  <!-- Name -->
  <div class="row">
    <div class="col-12 p-0 pt-2 fix-height">
      <h5 id="family-name" class="bold m-r-lg m-l-lg text-center">
        {{ hardGoodDetails?.familyName }}
      </h5>
    </div>
  </div>
  <!-- Image -->
  <div class="row device-details-fixheight">
    <div class="col-6">
      <a id="device-image" href="javascript:void(0)"
        ><img
          alt="FPO Image"
          class="img-fluid browse-image"
          [src]="currentDeviceDetails?.imageUrl"
        />
      </a>
    </div>
    <div class="col-6 p-0">
      <!-- Price -->
      <tmo-devices-pricing-panel
        [deviceAmount]="currentDeviceDetails?.payNowPrice"
        [id]="hardGoodDetails?.familyName"
        [isEpin]="hardGoodDetails?.isEpin"
        [pricingOptions]="pricingOptions"
        [isBrowseAccessory]="true"
        [isBrowseDevice]="true"
        [id]="hardGoodDetails?.offerId"
      >
      </tmo-devices-pricing-panel>
      <div class="row availabilityStatusDiv">
        <p
          id="availability-status"
          class="small bold ps-0 p-t-sm"
          [ngClass]="{
            'error-text':
              currentDeviceDetails?.availabilityStatus === availabilityStatusConstant?.BACKORDERED,
          }"
        >
          {{ this.availabilityStatus }}
        </p>
      </div>
      <!-- Memory Picker -->
      <div class="row mt-2" *ngIf="!hardGoodDetails?.isEpin && !hardGoodDetails?.isSimCard">
        <ng-container *ngFor="let memory of memoryOptions; let i = index">
          <span
            class="memory-radio device-memory-radio small"
            *ngIf="(i <= 2 && memoryOptions?.length <= 3) || (i <= 1 && memoryOptions?.length > 3)"
          >
            <input
              class="col-12"
              id="device-memory-{{ memory?.name }}"
              aria-label="Memory"
              [checked]="currentDeviceDetails?.memory === memory?.value"
              (click)="setSelectedMemory(memory?.value, index)"
              name="'memory'+{{ hardGoodDetails?.offerId }}"
              type="radio"
            />
            <span class="memory-box small normal">
              <p id="memory-id" class="small">{{ memory?.name }}</p>
            </span>
          </span>
        </ng-container>
        <div
          id="memory-swatch-seemore"
          class="pt-1 memory-radio device-memory-radio small m-t-sm m-l-sm"
          *ngIf="memoryOptions?.length > 3"
        >
          <span class=""
            ><a href="javascript:void(0)" (click)="memoryToolTip = !memoryToolTip">
              {{ contentData?.More }}
            </a>
          </span>
        </div>
      </div>
      <!-- Color Picker -->
      <div class="row pt-3" *ngIf="!hardGoodDetails?.isEpin && !hardGoodDetails?.isSimCard">
        <span
          class="color-device-radio color-radio small"
          *ngFor="let colors of hardGoodDetails?.itemDetails | slice: 0 : 3; let i = index"
        >
          <input
            id="device-color-{{ getColorName(colors?.colorName) }}"
            aria-label="Color"
            name="'radio'+{{ hardGoodDetails?.offerId }}"
            type="radio"
            (click)="selectColor(colors?.id, colors?.colorName, index)"
            [checked]="currentDeviceDetails?.colorName === colors?.colorName"
          />
          <span class="img-color">
            <img
              id="color-swatch-image"
              alt="{{ colors?.colorName }}"
              class="bg-gray-light small device-color-img"
              [src]="colors?.colorSwatchURL"
              class="bg-black"
            />
          </span>
        </span>
        <div
          id="color-swatch-seemore"
          class="col-3 lead small pt-2"
          *ngIf="hardGoodDetails?.itemDetails?.length > 3"
        >
          <span class=""
            ><a href="javascript:void(0)" (click)="colorToolTip = !colorToolTip">
              {{ contentData?.More }}
            </a>
          </span>
        </div>
      </div>
      <!-- SIM Type Picker -->
      <div
        class="row mt-2"
        *ngIf="
          !hardGoodDetails?.isEpin &&
          !hardGoodDetails?.isSimCard &&
          esimActivationsEnabled &&
          currentDeviceDetails?.deviceSimInfo &&
          currentDeviceDetails?.deviceSimInfo[0]
        "
      >
        <span
          class="memory-radio device-memory-radio small"
          *ngFor="let deviceSim of currentDeviceDetails?.deviceSimInfo; let i = index"
        >
          <input
            class="col-12"
            id="device-simType-{{ deviceSim.simType }}}}"
            aria-label="SimType"
            name="'radio'+{{ hardGoodDetails?.offerId }}+{{ sim }}"
            type="radio"
            (click)="selectSimInfo(deviceSim, i)"
            [checked]="
              currentDeviceDetails?.simInfo?.simType?.toLocaleLowerCase() ===
              deviceSim?.simType?.toLocaleLowerCase()
            "
          />
          <span class="memory-box small normal">
            <p id="simType-id" class="small">{{ deviceSim?.simType }}</p>
          </span>
        </span>
      </div>
    </div>
  </div>
  <div class="col-12 pt-2 m-t-xl text-center">
    <p id="legal-text" class="legal">
      {{ withoutQualifyingPlan }} {{ additionalChargesWithDevice }}
    </p>
  </div>
  <div class="row">
    <div class="col-12 p-g justify-content-center">
      <button
        id="device-select-cta"
        class="btn btn-primary m-t-lg"
        [disabled]="
          !isStoreOpen ||
          currentDeviceDetails?.availabilityStatus === availabilityStatusConstant?.OUT_OF_STOCK ||
          disableCta
        "
        (click)="checkExistingLines()"
        aria-label="Clickable action"
      >
        {{ contentData?.select }}
      </button>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <p class="m-t-lg m-b-lg text-center ms-2">
        <a id="details-link" href="javascript:void(0)" (click)="updateIndex(index)"
          >{{ toggleDetails[index] === true ? contentData?.hideDetails : contentData?.details }}
          <i
            class="fa m-l-sm"
            [ngClass]="toggleDetails[index] === true ? 'fa-angle-up' : 'fa-angle-down'"
          ></i
        ></a>
      </p>
    </div>
  </div>
  <tmo-spinner [setDelay]="!showSpinner"></tmo-spinner>
  <tmo-static-modal
    [modal]="mixedCartModal"
    (onSelect)="handleClickEvent($event)"
  ></tmo-static-modal>
</div>
<div
  class="color-swatch row m-t-md"
  *ngIf="hardGoodDetails?.itemDetails?.length > 3 && colorToolTip"
>
  <div class="box arrow-top">
    <div
      class="color-device-radio color-radio small"
      *ngFor="let colors of hardGoodDetails?.itemDetails; let i = index"
    >
      <input
        id="color-id"
        aria-label="Color"
        name="color-radio_sample"
        type="radio"
        (click)="selectColor(colors?.id, colors?.colorName, index)"
        [checked]="currentDeviceDetails?.colorSwatchId === colors?.id"
      />
      <span class="img-color">
        <img
          id="color-img-id"
          alt="{{ colors?.colorName }}"
          class="bg-gray-light small device-color-img"
          [src]="colors?.colorSwatchURL"
        />
      </span>
    </div>
  </div>
</div>
<div class="memory-swatch row m-t-md" *ngIf="memoryOptions?.length > 3 && memoryToolTip">
  <div class="box arrow-top">
    <div
      class="memory-radio device-memory-radio small"
      *ngFor="let memory of memoryOptions; let i = index"
    >
      <input
        id="memory-id"
        aria-label="Memory"
        name="memory-radio_sample"
        type="radio"
        (click)="setSelectedMemory(memory?.value, index)"
        [checked]="currentDeviceDetails?.memory === memory?.value"
      />
      <span class="memory-box small normal"
        ><p id="memory-id" class="small">{{ memory?.name }}</p></span
      >
    </div>
  </div>
</div>
<tmo-upgrade-multiline-modal
  [displayModal]="displayUpgradeMultilineModal"
  [aemContent]="contentData"
  [lineDetails]="cartExistingLines"
  (closeMultilineUpgradeModal)="closeUpgradeModal()"
  (onSelectUpgradeLine)="updateUpgradeLineSelected()"
></tmo-upgrade-multiline-modal>
